/*
 * The last query string a list page was showing, so a Back button elsewhere can
 * return to it with its filters, search and page intact.
 *
 * A list keeps its state in the URL (see useUrlState), which is lost as soon as
 * the user moves through another page — the branch's products screen, say —
 * before coming back. Browser history would go to that other page instead, so
 * a Back button that must land on the list reads it from here.
 *
 * Session storage: per tab, gone when the tab closes, and never shared. A
 * missing or unreadable entry simply means the list's defaults.
 */
const KEY = "list-url:";

export const rememberListSearch = (path, search) => {
  try {
    sessionStorage.setItem(KEY + path, search || "");
  } catch {
    // Private mode or storage full: Back still works, without the filters.
  }
};

/** `path` plus the query string it last had, e.g. `/products?search=gel&page=2`. */
export const rememberedListUrl = (path) => {
  let search = "";
  try {
    search = sessionStorage.getItem(KEY + path) ?? "";
  } catch {
    search = "";
  }
  return search.startsWith("?") ? `${path}${search}` : path;
};
